import { compact } from "lodash";
import _ from "lodash";
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from "react-dom";
import { useTranslation } from 'react-i18next';
import {useStoreActions, useStoreState} from "easy-peasy";
import { types } from "../lib/store";
import WarningAlert from "./Alerts/WarningAlert";
import {showOrHide} from "../lib/utils/helpers";
import {types as SimulationTypes} from "./Simulation";


const ServicePointDetail = ({ curve, metadata }) => {
  const { t } = useTranslation();
  const units = useStoreState(state => state.selection.units);

  return (
    <form className="form-horizontal">
      { showOrHide(_.get(curve, "rpm_angle.angle_string", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">{ t("frontend:fan.grades") }</label>
        <div className="col-sm-6">
          <input type="text" name="ps_graus" value={ _.get(curve, "rpm_angle.angle_string", "-") } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "rpm_angle.rpm_string", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">{ t("frontend:fan.speed") }</label>
        <div className="col-sm-6">
          <input type="text" name="ps_RPM" value={ _.get(curve, "rpm_angle.rpm_string", "-") } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "max_temperature", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">Temp. max. ({ t(`units:${units.temperature}`) })</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "max_temperature", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "flow", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">Q ({ t(`units:${units.flow}`) })</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "flow", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "static_pressure", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">Ps ({ t(`units:${units.pressure}`) })</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "static_pressure", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "dynamic_pressure", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">Pd ({ t(`units:${units.pressure}`) })</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "dynamic_pressure", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "total_pressure", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">Pt ({ t(`units:${units.pressure}`) })</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "total_pressure", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "impulsion_speed", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">{ t("frontend:fan.speed_air_ms") }</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "impulsion_speed", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "info.use_factor", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">{ t("frontend:fan.use_factor") }</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "info.use_factor", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "mechanical_total_efficiency", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">{ t("frontend:fan.mechanical_total_efficiency") } (%)</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "mechanical_total_efficiency", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "fan_total_efficiency", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">{ t("frontend:fan.fan_total_efficiency") } (%)</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "fan_total_efficiency", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "info.normalized_mec_power", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">
          { t("frontend:power_abbreviation") }<sub>mec</sub> (kW) { showOrHide(_.get(curve, "info.mec_power", 0)) && <>1.20 Kg/m<sup>3</sup></> }
        </label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "info.normalized_mec_power", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "info.mec_power", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">
          { t("frontend:power_abbreviation") }<sub>mec</sub> (kW) <span className="ps_Pm2_density">{ _.get(curve, "info.mec_power_density", 0).toFixed(2) } Kg/m<sup>3</sup></span>
        </label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "info.mec_power", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "info.abs_power", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">
          { t("frontend:power_abbreviation") }<sub>abs</sub> (kW) <span>{ _.get(curve, "info.abs_power_density", 0).toFixed(2) } Kg/m<sup>3</sup></span>
        </label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "info.abs_power", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "info.recommended_power", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">{ t("frontend:power_abbreviation") }<sub>recom</sub> (kW)</label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(metadata, "motor.power_string") } disabled className="form-control"/>
        </div>
      </div>}
      { showOrHide(_.get(curve, "info.specific_consumption", 0)) && <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">
          { t("frontend:fan.specific_consumption") } (W/l/s) <span>{ _.get(curve, "info.specific_consumption_density", 0).toFixed(2) } Kg/m<sup>3</sup></span>
        </label>
        <div className="col-sm-6">
          <input type="text" value={ _.get(curve, "info.specific_consumption", 0).toFixed(2) } disabled className="form-control"/>
        </div>
      </div>}
    </form>
  )
};

function ServicePoint() {
  const { t } = useTranslation();

  const fan = useStoreState(state => state.selection.fan);
  const { service_points, alternative_service_points, metadata } = useStoreState(state => state.selection.servicePoint);
  const showAlternativePoint = useStoreState(state => state.selection.showAlternativePoint);
  const activeAlternativePoint = useStoreActions(actions => actions.selection[types.TOGGLE_ALTERNATIVE_POINT]);
  const setPowerLine = useStoreActions(actions => actions.selection[types.SET_CUSTOM_POWER_LINE]);

  const designPoint = useStoreState(state => state.selection.designPoint);
  const simulationType = useStoreState(state => state.selection.customizations.simulationType);

  const [showPowerWarning, setShowPowerWarning] = useState(false);
  const [powerWarning, setPowerWarning] = useState({ title: "", message: "" });

  const hasAlternativePoint = compact(alternative_service_points).length > 0;
  const toggleClasses = hasAlternativePoint ? "btn btn-info btn-block panel-heading" : "btn btn-info btn-block panel-heading disabled";

  const toggleAlternativePoint = () => {
    if (hasAlternativePoint) {
      activeAlternativePoint();
    }
  };

  const currentPointsData = showAlternativePoint ? alternative_service_points : service_points;
  const [currentTab, setCurrentTab] = useState(0);

  const alertWarningRef = useRef(null);

  if (!alertWarningRef.current) {
    alertWarningRef.current = document.getElementById("service-point-power-alert-warning");

    if (alertWarningRef.current) {
      while (alertWarningRef.current.firstChild) {
        alertWarningRef.current.removeChild(alertWarningRef.current.firstChild);
      }
    }
  }

  const toggleTab = (ev) => {
    ev.preventDefault();

    setCurrentTab(parseInt(ev.target.dataset.tabIndex));
  };

  useEffect(() => {
    setCurrentTab(0);
    setShowPowerWarning(false);

    if (fan.hasMotor || !metadata) {
      // setShowPowerWarning(false);
      // setPowerLine({ motorId: null, power: "" });
    }
    else {
      const currentMotor = (showAlternativePoint ? metadata['alternative_service_points']['motor'] : metadata['service_points']['motor']) || {};
      const mechanicalMinPowerWarning = showAlternativePoint ? metadata['alternative_service_points']['min_power'] : metadata['service_points']['min_power'];
      let mechanicalPowerWarning = showAlternativePoint ? metadata['alternative_service_points']['mec_power'] : metadata['service_points']['mec_power'];
      mechanicalPowerWarning = mechanicalPowerWarning * ( 1 + ( metadata['security_coefficient'] / 100 ) );

      if (currentMotor.power) {
        setPowerLine({ motorId: currentMotor.id, power: currentMotor.power });
      }

      // Consideramos que el motor que recomendaríamos es justo el siguiente motor con potencia
      // superior a ( Pmec * SecurityCoefficient ). Si el motor que recomendaríamos es inferior
      // a la potencia mínima que puede montar el ventilador, lo avisamos.
      if (mechanicalMinPowerWarning !== 0 && mechanicalMinPowerWarning < fan.minPower) {
        setPowerWarning({
          title: "frontend:modal.warning.title",
          message: "frontend:fan.warnings.recommended_power.lower"
        });
        setShowPowerWarning(true);
      }

      // Aquí avisamos si el motor que hemos recomendado (que siempre será uno que se pueda montar
      // en el ventilador) no tiene suficiente potencia. O sea la potencia es inferior a ( Pmec * SecurityCoefficient ).
      if (mechanicalPowerWarning !== 0 && mechanicalPowerWarning > currentMotor.power) {
        setPowerWarning({
          title: "frontend:modal.warning.title",
          message: "frontend:fan.warnings.recommended_power.higher"
        });
        setShowPowerWarning(true);
      }
    }
  }, [showAlternativePoint, service_points, alternative_service_points, fan.hasMotor, fan.minPower, metadata, setPowerLine]);

  const getTabName = (curve) => {
    if (simulationType === SimulationTypes.FREQUENCY && designPoint.frequency !== fan.frequency) {
      let title = _.trim(`${curve['curve_name']} ${curve['frequency']} Hz`);
      if(curve['frequency'] !== fan.frequency) {
          title += ' VSD'
      }
      return title;
    } else {
      return curve['curve_name'];
    }
  };

  return (
    <>
      {
        showAlternativePoint &&
        <div>
          <button className="btn btn-info btn-block panel-heading" onClick={toggleAlternativePoint}>{ t("frontend:fan.service_point") }</button>
        </div>
      }
      <div className="panel panel-info">
        <div className="panel-heading">
          { showAlternativePoint ? t("frontend:fan.alternative_point") : t("frontend:fan.service_point") }
        </div>
        {
          currentPointsData &&
          <div className="panel-body">
            {
              currentPointsData.length > 1 &&
              <ul className="nav nav-tabs" style={{marginBottom: "15px"}}>
                {currentPointsData.map((curve, index) =>
                  <li key={`${curve.curve_id}-${curve.flow}-${curve.static_pressure}`} className={index === currentTab ? "active" : ""}>
                    <a href="#" data-tab-index={index} onClick={toggleTab}>{getTabName(curve)}</a>
                  </li>
                )}
              </ul>
            }
            <div className="tab-content">
              {currentPointsData.map((curve, index) =>
                <div key={`${curve.curve_id}-${curve.flow}-${curve.static_pressure}`} className={index === currentTab ? "" : "hidden"}>
                  <ServicePointDetail
                    curve={curve}
                    metadata={_.get(metadata, (showAlternativePoint ? "alternative_service_points" : "service_points"), {})}
                  />
                </div>
              )}
            </div>
          </div>
        }
      </div>
      {
        !showAlternativePoint &&
        <div>
          <button className={toggleClasses} onClick={toggleAlternativePoint}>{ t("frontend:fan.alternative_point") }</button>
        </div>
      }
      {
        showPowerWarning && ReactDOM.createPortal(
          <WarningAlert
            title={ t(powerWarning.title) }
            message={ t(powerWarning.message) }
          />
          , alertWarningRef.current
        )
      }
    </>
  );
}

export default ServicePoint;
